import {type GlobalState} from 'types/store';

export function getUserThreadsSliceState(state: GlobalState) {
    return state.userThreads;
}
